import { IconButtonProps } from '@rjsf/utils';
import { ChevronDown } from 'lucide-react';
import { Button } from '../../Button';

export const ShMoveDownButton = (props: IconButtonProps) => (
  <Button
    variant="ghost"
    size="icon"
    onClick={props.onClick}
    disabled={props.disabled}
    title="Move item down"
  >
    <ChevronDown className="h-4 w-4" />
  </Button>
);
